/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SpaProductTypeDTO = {
    WELLNESS_OASE: 'WELLNESS_OASE',
    TREATMENT: 'TREATMENT'
} as const;
export type SpaProductTypeDTO = typeof SpaProductTypeDTO[keyof typeof SpaProductTypeDTO];

